export type LibrarySectionKey = "categories" | "templates" | "policies" | "post_tags";

export function linesToPatterns(text: string): { kind: "substring"; value: string }[] {
  return text
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean)
    .slice(0, 40)
    .map((value) => ({ kind: "substring" as const, value: value.slice(0, 500) }));
}
